import React from 'react';
import { Space, Breadcrumb } from 'antd';
import { CardLayout, B2BAskTable } from 'components/molecules';
import SearchBox from './SearchBox'
import { useProjectAsk } from 'hooks';
export interface  ProjectAskProps {}

const  ProjectAsk = ({}:  ProjectAskProps): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */

  const { askList, searchResult, refetch } = useProjectAsk();  

  /* ======================================================
   * variables
   * ====================================================== */


  /* ======================================================
   * events
   * ====================================================== */    

  /* ======================================================
   * hooks
   * ====================================================== */
 
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>B2B</Breadcrumb.Item>
        <Breadcrumb.Item>문의</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <SearchBox />
          <B2BAskTable askList={askList} searchResult={searchResult} refetch={refetch} myPage={'none'} />          
        </Space>                
    </CardLayout>
  )
};

export default  ProjectAsk;    